<template>

    <v-dialog
      :value="dialog"
      max-width="1000px"
    >
      <v-btn
        slot="activator"
				:fab="this.$vuetify.breakpoint.name === 'xs'"
        fixed
        bottom
        right
        large
        class="mb-5 mr-0 accent elevation-8"
      >
        <v-icon :left="this.$vuetify.breakpoint.name != 'xs'">call_split</v-icon> 
        <span class="hidden-xs-only">Anfrage Senden</span>
      </v-btn>
      <v-card>
         <component :is="componentInstance" :leistung="this.leistung" :stadt="this.stadt" />
      </v-card>
    </v-dialog>
</template>

<script>

export default {
  props: ['stadt', 'leistung', 'openmodal'],
  data () {
    return {
      show: true,
      dialog: false,
      text: '',
      block: false,
      loading: false,
      email: '',
      telefon: '',
      name: '',
      valid: false,
      textRules: [
        v => !!v || 'Bitte Text angeben',
        v =>
          (v && v.length <= 800) ||
          'Bitte nicht mehr als 800 Buchstaben verwenden.'
      ],
      daten: {
        vorauswahl: '',
        typ: null,
        leistungen: null,
        objektart: null,
        stadt: ''
      },
      kontakt: {
        name: '',
        email: '',
        telefon: ''
      }
    }
  },
  components: {
  },
  methods: {
    openmodalfunction: function () {
      console.log('openmodal..')
      this.dialog = true
    }
  },
  computed: {
    componentInstance () {
      const id = this.leistung.gewerk.wizard
     // console.log(this.leistung)
      const Foo = () => import(/* webpackChunkName: "prem-profile" */ `~/components/anfragen/wizards/${id}`)
      try {
        return Foo
      } catch (e) {
        console.log('Kein wizard gefunden')
      }
    }
  }
}
</script>
<style>
</style>